export default "__VITE_ASSET__DpvRc_sH__"